import { gql } from "@apollo/client";
export const FindUncompletedProviderTransactions = gql `
  query FindUncompletedProviderTransactions(
    $input: FindUncompletedProviderTransactionsInput!
  ) {
    FindUncompletedProviderTransactions(input: $input) {
      _id
      amount
      company {
        _id
        name
      }
      dueDate
      external {
        _id
        name
      }
      transactionIdentifier
      sourceBankAccount {
        currency
      }
      destinationBankAccount {
        currency
      }
    }
  }
`;
